import { forwardRef, type PropsWithChildren, type ReactNode } from 'react'

type Props = PropsWithChildren<{
  sidebarContent: ReactNode
}>
export const ShipmentFormPageLayout = forwardRef<HTMLDivElement, Props>(
  ({ sidebarContent, children }: Props, ref) => {
    return (
      <div className="shipper-page-fill shipper-grid-rows-single-fill grid grid-cols-[20rem_1fr] b1350:block">
        <div className="min-h-0 min-w-0">{sidebarContent}</div>

        <div ref={ref} className="relative min-h-0 h-full overflow-auto">
          {children}
        </div>
      </div>
    )
  },
)
